<template>
    <div class="container">
        <section
            class="row align-items-center justify-content-center"
            v-if="$store.getters.isLoading"
        >
            <div class="loading-box col-md-4">
                <div class="spinner"></div>
                <div class="title">Loading...</div>
                <div class="text" v-if="$store.getters.loadingMsg">
                    {{ $store.getters.loadingMsg }}
                </div>
            </div>
        </section>

        <section class="row"
            v-if="recoveredFormData && !dismissed && formType !== null ">
           
            <div class="col-lg-8 offset-lg-2">
              <div class="alert alert-info my-3" role="alert">
             <h4 class="alert-heading">We recovered your data</h4>
                    <p>
                        We found a partially filled out form from a previous
                        session. This data has been restored so you can continue
                        where you left off.
                    </p>
                    <div class="d-flex justify-content-end align-items-center">
                        <button
                            class="btn btn-secondary"
                            @click="dismissed = true"
                        >
                            Close
                        </button>
                    </div>
               </div>
            </div>
        </section>

        <!--If errors exist savedAppValidationList  -  Commented out based on feedback ...just bring user to step 1 
        <section v-if="savedAppValidationList.length > 0" class="row">
            <div class="col-lg-8 offset-lg-2 alert alert-danger">
                    Please <a href="#" @click="ResetSavedAppValidationList()">review and correct</a> invalid input value(s) from previous steps before continue.
            </div>
        </section>
        -->
        <section class="row text-right" v-if="formType !== null">
            <div class="col-lg-10 offset-lg-1">
                <!-- TODO: save application - Only display "Save" button after step 4 for "Tivi Series" -i.e. "FILM07"- production type--> 
                <!--
                <span v-if ="formData.ProductionType== 'FILM07'">
                    <button v-if="step >= 5" @click="SaveApplication" class="btn-SaveAndExit btn btn-secondary btn-Color mt-3 ml-3">Save</button>
                </span>
                <span v-else>
                    <button v-if="step >= 3" @click="SaveApplication" class="btn-SaveAndExit btn btn-secondary btn-Color mt-3 ml-3">Save</button>
                </span>
                -->

                <button v-if="step >= 3" @click="SaveApplication" class="btn-SaveAndExit btn btn-secondary btn-Color mt-3 ml-3">Save</button>
                <!--exit application-->
                <b-button id="show-btn" class="btn-SaveAndExit btn btn-sm btn-secondary btn-Color mt-3 ml-3" v-b-modal="'ExitConfirmModal'">Exit</b-button>
                <b-modal 
                    id="ExitConfirmModal" 
                    hide-footer
                    @ok="ProcessExit(index)"
                >
                    <template #modal-title>
                        Exit this application?
                    </template>
                    <div @click="$bvModal.hide('ExitConfirmModal')" style="float:right;margin-top:-60px; padding-right: 20px; cursor:pointer;">Close</div>
                    <div v-if="step >= 3">
                        <div class="d-block text-left mt-3">          
                            Do you want to save your progress made to the application before you exit?
                        </div>
                        <div class="float-left mt-3"> 
                            <b-button @click="CancelExit()" class="btn btn-reject mr-3">Don't save</b-button>
                            <b-button @click="ProcessExit()" class="btn btn-primary">Save</b-button>    
                        </div>    
                    </div>
                    <div v-else>
                        <div class="d-block text-left mt-3">                        
                            Do you want to exit your application?
                        </div>
                        <div class="float-left mt-3"> 
                            <b-button @click="ProcessExit()" class="btn btn-primary">Yes</b-button>
                            <b-button @click="CancelExit()" class="btn btn-reject ml-3">No</b-button>
                        </div>    
                    </div>    
                </b-modal>

                
            </div>
        </section>

        <b-modal id="modal-TVSeries" ok-only hide-header hide-footer>
            <div class="d-block text-left">To save your progress for a TV series permit application, please complete Step 4.</div>
            <div class="float-right mt-3"> 
                        <b-button @click="hideModal()">OK</b-button>
            </div>   
        </b-modal>

        <div class="col-lg-10 offset-lg-1 d-block no-gutters pl-0">
            <AlertMessage v-if="displayAlert" :message="alertMessage" :alertType="alertType"></AlertMessage>
        </div>

        <div class="row mb-3" v-if="formType !== null">
            <div class="col-lg-10 offset-lg-1">
                <h1>
                    {{
                        formType === 'grid'
                            ? 'Grid (city all) application'
                            : 'Film permit application'
                    }}
                </h1>

                <div class="flex-wrap mr-5 mb-2 pr-3 mt-1">
                    To apply for a new permit, complete and submit this form.<br/>
                    Manage your application through the film permit <router-link to="/dashboard" style="display: inline;color:#00629B;text-decoration: underline;">dashboard</router-link>.

                    <label v-show="formType == 'grid'">
                        <br/>A GRID permit is for camera-in-car filming, with the flow of traffic only. Please return to dashboard and apply for a standard film permit for all other filming requests. 
                    </label>
                </div>
            </div>
        </div>

        
        <div class="row" v-if="formType !== null">
            <div class="col-lg-10 offset-lg-1">
                <section
                    class="step-container"
                    v-for="(item, key) in stepComponents"
                    :key="'step-' + key"
                    :id="'step-' + key"
                    style="overflow:visible"
                >
                    <div
                        class="step-heading"
                        :class="[
                            status[key] ? 'complete' : null,
                            step == key
                                ? 'active'
                                : step < key && !status[key - 1]
                                ? 'disabled'
                                : null,
                        ]"
                        @click="changeStep(key)"
                    >
                        <div>
                            <div class="step-heading__number">{{ key }}</div>
                            <h2>
                                <span class="sr-only">Step {{ key }}</span>
                                {{ item.text }}
                            </h2>
                        </div>
                        <span class="complete-flag" v-if="status[key]">
                            <font-awesome-icon icon="check" />
                        </span>
                    </div>
                    <component
                        :is="item.component"
                        :formType="formType"
                        v-if="step == key"
                        @changeStep="changeStep"
                        refs="formComponent"
                        v-focus
                    ></component>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import smoothReflow from '@/mixins/vue-smooth-reflow';
import StepOneForm from '@/components/step-1/StepOneForm.vue';
import StepTwoForm from '@/components/step-2/StepTwoForm.vue';
import StepThreeForm from '@/components/step-3/StepThreeForm.vue';
import StepFourForm from '@/components/step-4/StepFourForm.vue';
import StepFiveForm from '@/components/step-5/StepFiveForm.vue';
import StepSix from '@/components/step-6/StepSix.vue';
import SavedApplications from '@/components/SavedApplications.vue';
import AlertMessage from "@/components/PagesRelated/AlertMessage";
import { mapActions, mapState } from 'vuex'  //, mapGetters

export default {
    name: 'PermitApplication',
    mixins: [smoothReflow],
    components: {
        StepOneForm,
        StepTwoForm,
        StepThreeForm,
        StepFourForm,
        StepFiveForm,
        StepSix,
        SavedApplications, 
        AlertMessage
    },
    data() {
        return {
            dismissed: false,
            displayAlert:false,
            alertMessage: '',
            alertType:'',
        };
    },
    computed: {
        status() {
            let stepObj = {};
            for (let i = 0; i < 5; i++) {
                stepObj[i + 1] = this.$store.getters.getStepComplete(i + 1);
            }
            return stepObj;
        },
        step: {
            get() {
                return this.$store.getters.getStep;
            },
            set(val) {
                this.$store.dispatch('SET_STEP', val);
            },
        },
        recoveredFormData() {
            return this.$store.getters.formDataWasRecovered;
        },      
        formType: {
            get() {
                return this.$store.getters.formType;
            },
            set(val) {
                this.$store.dispatch('SET_TYPE', val);
            },
        },
        stepComponents() {
            if (this.formType !== 'grid') {
                return {
                    1: { component: 'StepOneForm', text: 'Business details' },
                    2: {
                        component: 'StepTwoForm',
                        text: 'Filming Information',        //OLD: Production information
                    },
                    3: { component: 'StepThreeForm', text: 'Filming Locations' },
                    4: { component: 'StepFourForm', text: 'Filming details' },
                    5: {
                        component: 'StepFiveForm',
                        text: 'Parking lots and roads',
                    },
                    6: { component: 'StepSix', text: 'Review' },
                };
            } else {
                return {
                    1: { component: 'StepOneForm', text: 'Business Details' },
                    2: {
                        component: 'StepTwoForm',
                        text: 'Filming information',     //OLD: Production information
                    },
                    //3: { component: 'StepThreeForm', text: 'Filming details' },  
                    3: { component: 'StepFourForm', text: 'Filming details' },
                    4: { component: 'StepSix', text: 'Review' },
                };
            }
        },
        ApplicationName: {
            get() {
                return this.formSavedData.ApplicationName;
            },
            set(value) {
                var appName = value;
                this.$store.dispatch('SETSTATE_VALUE', {name:'ApplicationName',value: appName,type: 'savedFormData'});
            }
        },
/*
        SavedAppTableData()
        {
            //const result = this.savedApplications.map((item,index) => {
            const result = this.formSaveDataList.map((item,index) => {
                            return {
                                Id: item.Id,
                                Index: index,
                                Name: item.ApplicationName,
                                CompanyName: item.CompanyName,
                                Step: item.Step,
                                CreatedOn: item.CreatedOn,
                                Action: item.CompanyName + " " + index
                            };
                            }); 
            return result;
        },
*/         
        ...mapState(['formData','formSaveDataList','formSavedData','savedAppValidationList'])
       
    },
    methods: {
        changeStep(payload) {
            if (
                this.$store.getters.getStepComplete(payload - 1) ||
                payload == 1
            )
                this.step = payload;
        },
        resetForm() {
            if (
                window.confirm(
                    "You're about to clear this form. You'll lose any information that you've entered so far. \nAre you sure you want to do this?"
                )
            ) {
                this.$store.dispatch("RESET_FORM").then(() => {
                    this.$router.push("dashboard");
                });
            }
        },
        nextStep() {
            this.submitted = true;

            if (!this._errorsExist()) {
                this.$store.dispatch('COMPLETE_STEP', {
                    step: this.step,
                    complete: true,
                });
                this.$emit('nextStep');
            }
        },

        SaveApplication()
        {
            this.submitted = true;
            if (this.formData.ProductionType == 'FILM07' && this.step < 5 && this.formType !="grid") {
                //alert ("This is TV Series needs to fill up until end of Step 4")
                this.$root.$emit('bv::show::modal', 'modal-TVSeries', '#btnShow');
            return false;
            }
            if (!this._errorsExist() ) {
               /* Bkup
               this.$store.dispatch('SAVE_FORMDATA').then(() => {
                        //display alert msg.
                        this.displayAlert = true;
                        this.alertMessage = "Your appplication is saved.";
                        this.alertType = "info";
                        setTimeout(() => {this.displayAlert = false;}, 3000);
					})
                */
                this.$store.dispatch('SAVE_FORMDATA').then(resp => {
                    switch (resp) {
                        case "input error": {
                            this.alertMessage = "There is an invalid input for saving.";
                            this.alertType = "warning";
                            break;
                        }
                        case "saving process error": {
                            this.alertMessage = "There is an issue with your save request. Please complete the application and submit";
                            this.alertType = "warning";
                            break;
                        }
                        case "server error": {
                            this.alertMessage = "There was an issue processing your request.";
                            this.alertType = "warning";
                            break;
                        }
                        case "success": {
                            this.alertMessage = "Your appplication is saved.";
                            this.alertType = "success";
                            break;
                        }
                        default: {
                            this.alertMessage = "Your appplication is saved.";
                            this.alertType = "info";
                        }
                    }
                    
                    //display alert msg.
                    this.displayAlert = true;
                    setTimeout(() => {this.displayAlert = false;}, 5000);
                })
                .catch(err =>{
                    this.alertMessage = err;
                    this.alertType = "info";
                    this.displayAlert = true;
                    setTimeout(() => {this.displayAlert = false;}, 5000);
                });
            }

        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-TVSeries', '#btnShow')
        },
        currentDateTime() {
            const current = new Date();
            const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+ current.getDate();
            const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
            const dateTime = date +' '+ time;
            
            return dateTime;
        },
        CancelExit() {
            //this.$root.$emit('bv::hide::modal', 'ExitConfirmModal', '#ExitModal')
            this.$nextTick(() => {
                this.$bvModal.hide('ExitConfirmModal');
                })
            if(this.step >= 3) 
            {
                this.$router.push("dashboard");
            }
            else
            {
                return false;
            }
            //return false;

        },
        /*
        ProcessExit_BKUP() {
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('ExitConfirmModal');
                })

            
            this.$store.dispatch("RESET_FORM").then(() => {
                this.$router.push("dashboard");
            });
    
        },*/
        RedirectToDashBoard() {
            const thisSelf = this;
            thisSelf.$router.push("dashboard");
        },
        ProcessExit() {
      
            //if user chooses to "exit application" and confirm "yes" to exit
            //only redirect user to "dashboard" after step 3 
            //else perform "save" data before exit.
            if(this.step >= 3) 
            {
                if (this.formData.ProductionType == 'FILM07' && this.step < 5 && this.formType !="grid") {
                    this.$bvModal.hide('ExitConfirmModal');
                    this.displayAlert = true;
                    this.alertMessage = "To save your progress for a TV series permit application, please complete Step 4.";
                    this.alertType = "info";
                    setTimeout(() => {this.displayAlert = false;}, 5000);
                    return false;
                }
                else
                {
                    // Trigger save handler
                    this.$store.dispatch('SAVE_FORMDATA');

                    //const thisSelf = this;
                    //function RedirectToDashBoard() {
                    //    thisSelf.$router.push("dashboard");
                    //}
                    //thisSelf.$router.push("dashboard");
                    this.RedirectToDashBoard()

                    // Hide the modal manually
                    this.$nextTick(() => {
                            this.$bvModal.hide('ExitConfirmModal');
                            //display alert msg.
                            this.displayAlert = true;
                            this.alertMessage = "Your appplication is saved.";
                            this.alertType = "success";
                            setTimeout(() => {this.displayAlert = false;}, 3000);
                            setTimeout(function () { this.RedirectToDashBoard() }.bind(this), 3000);
                        })

                    //this.$router.push("dashboard");
                }
            }
            else //redirect user to "dashboard"
            {
                this.$store.dispatch("RESET_FORM").then(() => {
                    this.$router.push("dashboard");
                });
            } 
    
        },
        ResetSavedAppValidationList()
        {
            this.$store.dispatch("RESETSTATE_VALUE",{name:'savedAppValidationList', type:'ArrayTypes'})
            //this.savedAppValidationList =[];
            this.step = 1;
        },

            ...mapActions(["SAVE_FORMDATA","GOTO_SAVEDAPP","DEACTIVE_SAVEDFORMDATA","SET_SAVED_APPLICATIONNAME"]),
        },
    mounted() {
        this.$smoothReflow({
            el: '#step-1',
            hideOverflow: true,
        });
        this.$smoothReflow({
            el: '#step-2',
            hideOverflow: true,
        });
        this.$smoothReflow({
            el: '#step-3',
            hideOverflow: true,
        });
        this.$smoothReflow({
            el: '#step-4',
            hideOverflow: true,
        });
        this.$smoothReflow({
            el: '#step-5',
            hideOverflow: true,
        });
        this.$smoothReflow({
            el: '#step-6',
            hideOverflow: true,
        });

        this.$store.dispatch('SET_LATEST_COMPLETED_STEP');

        // start watching the session to get a relog before the session expires
        const self = this;
        function userInterval() {
            //check every minute to see if the session is valid.
            const token = JSON.parse(sessionStorage.getItem('access_token'));

            if (token) {
                const [expires, timeSinceLogin] = [
                    token.expires_in - 600,
                    (Date.now() - token.created_time) / 1000,
                ];

                if (timeSinceLogin - expires >= 0) {
                    self.$store.dispatch('BACKUP_FORMDATA');
                    self.$store.dispatch('USER_LOGOUT').then(() => {
                        self.$router.push('/login?expired');
                    });
                }
            }
        }

        setInterval(userInterval, 1000000); //10000 - 1000000
    },
    updated() {
        // Override the overflow:hidden IE11 bug from smooth reflow
        document.querySelectorAll('.step-container').forEach((node) => {
            ['overflow', 'overflowX', 'overflowY'].forEach(
                (key) => (node.style[key] = 'visible')
            );
        });

    }
};
</script>

